(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessories-slider"] && !Shopify.designMode) return;
  try {
    
"use strict";
(function () {
  if (!customElements.get("accessories-slider")) {
    class AccessoriesSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
        this.swiper = null;
      }

      connectedCallback() {
        this.setupElements();
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy();
        }
      }

      setupElements() {
        this.slider = this.querySelector('[data-component="slider"]');
        this.scrollbar = this.querySelector(".swiper-scrollbar");
        this.btnsNext = this.querySelectorAll(".swiper-button-next");
        this.btnsPrev = this.querySelectorAll(".swiper-button-prev");
      }

      initSwiper() {
        if (!this.slider) return;

        let {
          spaceBetween,
          spaceBetweenMb,
          slidesPerView,
          slidesPerViewTb,
          slidesPerViewMb,
          sliderLength,
        } = this.dataset;

        spaceBetween = +spaceBetween.replace("px", "");
        spaceBetweenMb = +spaceBetweenMb.replace("px", "");

        slidesPerView =
          +slidesPerView > +sliderLength ? sliderLength : +slidesPerView;
        slidesPerViewTb =
          +slidesPerViewTb > +sliderLength ? sliderLength : +slidesPerViewTb;
        slidesPerViewMb =
          +slidesPerViewMb > +sliderLength ? sliderLength : +slidesPerViewMb;

        // !important: WHEN CHANGE breakpoints - don't forget change breackpoint for not initialized slider in css file

        this.swiper = new Swiper(this.slider, {
          slidesPerView: slidesPerViewMb,
          spaceBetween: spaceBetweenMb,
          grabCursor: true,
          loop: true,
          slideToClickedSlide: true,
          navigation: {
            nextEl: this.btnsNext[0],
            prevEl: this.btnsPrev[0],
          },
          scrollbar: {
            el: this.scrollbar,
            draggable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewTb,
              spaceBetween: spaceBetween,
            },
            1200: {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetween,
            },
          },
        });
      }
    }

    customElements.define("accessories-slider", AccessoriesSlider);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-au"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector("[data-spd-au]");
  if (!root) return;

  // Formatters (AUD)
  var C0 = (n) =>
    new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      maximumFractionDigits: 0,
    }).format(n);
  var C2 = (n) =>
    new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      maximumFractionDigits: 2,
    }).format(n);
  var q = (s) => root.querySelector(s);

  // Pricing/GST
  var RETAIL_INC = 4799; // incl. GST
  var RETAIL_EX = +(RETAIL_INC / 1.1).toFixed(2); // ex GST

  // Defaults
  var members = 2,
    years = 3,
    mode = "pt",
    travel = "public",
    timeOn = true,
    childcareOn = true,
    gstMode = "incl";

  // Outputs
  var O = {
    hero: q('[data-out="hero"]'),
    mon: q('[data-out="month"]'),
    brk: q('[data-out="break"]'),
    per: q('[data-out="per"]'),
    tSpd: q('[data-out="t-spd"]'),
    tGym: q('[data-out="t-gym"]'),
    tSav: q('[data-out="t-save"]'),
    p1: q('[data-out="p1"]'),
    p2: q('[data-out="p2"]'),
    p3: q('[data-out="p3"]'),
    barS: q('[data-out="bar-s"]'),
    barG: q('[data-out="bar-g"]'),
    vS: q('[data-out="v-s"]'),
    vG: q('[data-out="v-g"]'),
    modeLbl: q('[data-out="mode-lbl"]'),
    barLbl: q('[data-out="bar-lbl"]'),
    breakdown: q('[data-out="breakdown"]'),
  };

  // Inputs
  var I = {
    people: q('[data-role="people"]'),
    mode: q('[data-role="mode"]'),
    years: q('[data-role="years"]'),
    travel: q('[data-role="travel"]'),
    time: q('[data-role="time"]'),
    child: q('input\[name="child"\]'),
    gst: q('[data-role="gst"]'),

    gym: q('input[name="gym"]'),
    pt: q('input[name="pt"]'),
    ptw: q('select[name="ptw"]'),

    // common
    trips: q('input[name="trips"]'),
    vhr: q('input[name="vhr"]'),

    // public
    fare: q('input[name="fare"]'),
    mins_pub: q('input[name="mins_pub"]'),

    // car
    km: q('input[name="km"]'),
    ppk: q('input[name="ppk"]'),
    mins_car: q('input[name="mins_car"]'),
  };

  function setOn(container, btn) {
    container
      .querySelectorAll(".chip")
      .forEach((x) => x.classList.remove("is-on"));
    btn.classList.add("is-on");
  }

  function showScope(kind) {
    var pub = root.querySelectorAll('[data-scope="public"]');
    var car = root.querySelectorAll('[data-scope="car"]');
    const trips = root.querySelector("[data-scope='public-trip']");
    const carTrips = root.querySelector("[data-scope='car-trip']");

    if (!pub || !car) return;
    if (kind === "public") {
      if (pub.length > 0) {
        pub.forEach((p) => (p.style.display = "grid"));
      }

      if (car.length > 0) {
        car.forEach((c) => (c.style.display = "none"));
      }
    } else {
      if (pub.length > 0) {
        pub.forEach((p) => (p.style.display = "none"));
      }

      if (car.length > 0) {
        car.forEach((c) => (c.style.display = "grid"));
      }
    }

    if (trips && carTrips) {
      if (kind === "public") {
        trips.style.display = "block";
        carTrips.style.display = "none";
      } else {
        trips.style.display = "none";
        carTrips.style.display = "block";
      }
    }
  }

  function spdPrice() {
    return gstMode === "incl" ? RETAIL_INC : RETAIL_EX;
  }

  function compute() {
    var gymFee = +I.gym.value || 0; // per person per month
    var ptRate = +I.pt.value || 0; // per session
    var ptPerW = +I.ptw.value || 0;
    var tripsWk = +I.trips.value || 0;

    if (mode === "gym") ptPerW = 0;

    // Annual base costs
    var membershipAnnual = gymFee * 12 * members;
    var ptAnnual = ptRate * ptPerW * 52 * members;

    // Travel
    var travelAnnual = 0,
      travelDesc = "",
      mins = 0;
    if (travel === "public") {
      var fare = +I.fare.value || 0;
      travelAnnual = fare * tripsWk * 52 * members;
      mins = +I.mins_pub.value || 0;
      travelDesc =
        "Public transport: " + C2(fare) + "/trip × " + tripsWk + "/wk";
    } else {
      var km = +I.km.value || 0;
      var ppk = +I.ppk.value || 0;
      travelAnnual = km * ppk * tripsWk * 52 * members;
      mins = +I.mins_car.value || 0;
      travelDesc =
        "Car: " + km + " km/rt × " + C2(ppk) + "/km × " + tripsWk + "/wk";
    }

    // Time value
    var timeAnnual = 0,
      timeDesc = "";
    if (timeOn) {
      var vhr = +I.vhr.value || 0;
      timeAnnual = (mins / 60) * vhr * tripsWk * 52 * members;
      timeDesc = "Time: " + mins + " min/rt × " + C2(vhr) + "/hr";
    }

    // Childcare
    var childcareOn = I.child.checked;
    var childAnnual = childcareOn ? 1.5 * 10 * 52 : 0;
    var childDesc = childcareOn ? "Childcare: A$10/hr × 1.5hr/wk" : null;

    var gymAnnual =
      membershipAnnual + ptAnnual + travelAnnual + timeAnnual + childAnnual;
    var gymTotal = gymAnnual * years;
    var spdTotal = spdPrice();

    var save = Math.max(0, gymTotal - spdTotal);
    var savePm = save / (years * 12);
    var perPersonPm = spdTotal / (years * 12) / members;
    var brkMonths = gymAnnual > 0 ? Math.ceil(spdTotal / (gymAnnual / 12)) : 0;

    // Outputs
    O.hero.textContent =
      "Save " + C0(save) + " over " + years + " year" + (years > 1 ? "s" : "");
    O.mon.textContent = C2(savePm) + " per month back";
    O.brk.textContent = "Break even: " + (brkMonths || "—") + " months";
    O.per.textContent =
      "Speediance ≈ " + C2(perPersonPm) + " per person monthly";

    var max = Math.max(spdTotal, gymTotal);
    O.barS.style.width = Math.max(8, Math.round((spdTotal / max) * 100)) + "%";
    O.barG.style.width = Math.max(8, Math.round((gymTotal / max) * 100)) + "%";
    O.vS.textContent = C0(spdTotal);
    O.vG.textContent = C0(gymTotal);

    O.tSpd.textContent = C0(spdTotal);
    O.tGym.textContent = C0(gymTotal);
    O.tSav.textContent = C0(save);

    var ptxt = years === 1 ? "1 year" : years + " years";
    O.p1.textContent = ptxt;
    O.p2.textContent = ptxt;
    O.p3.textContent = ptxt;
    O.modeLbl.textContent = mode === "pt" ? "Gym + PT" : "Gym only";
    O.barLbl.textContent = mode === "pt" ? "Gym + PT" : "Gym only";

    var parts = [
      "Gym membership: " + C0(membershipAnnual) + "/yr (" + members + "×)",
      mode === "pt" && ptPerW > 0 ? "PT: " + C0(ptAnnual) + "/yr" : null,
      travelDesc ? travelDesc + " → " + C0(travelAnnual) + "/yr" : null,
      timeDesc && timeOn ? timeDesc + " → " + C0(timeAnnual) + "/yr" : null,
      childDesc ? childDesc + " → " + C0(childAnnual) + "/yr" : null,
    ]
      .filter(Boolean)
      .join("  •  ");
    O.breakdown.textContent = parts;
  }

  function chipGroup(container, setter) {
    if (!container) return;
    container.addEventListener("click", function (e) {
      var b = e.target.closest(".chip");
      if (!b) return;
      e.preventDefault();
      setOn(container, b);
      setter(b);
    });
  }

  // Wire chip groups
  chipGroup(I.people, (b) => {
    members = +b.dataset.m;
    compute();
  });
  chipGroup(I.mode, (b) => {
    mode = b.dataset.mode;
    compute();
  });
  chipGroup(I.years, (b) => {
    years = +b.dataset.y;
    compute();
  });
  chipGroup(I.travel, (b) => {
    travel = b.dataset.travel;
    showScope(travel);
    compute();
  });
  chipGroup(I.time, (b) => {
    timeOn = b.dataset.time === "on";
    compute();
  });
  chipGroup(I.gst, (b) => {
    gstMode = b.dataset.gst;
    compute();
  });

  // Inputs events
  [
    "gym",
    "pt",
    "ptw",
    "trips",
    "fare",
    "mins_pub",
    "km",
    "ppk",
    "mins_car",
    "vhr",
    "child",
  ].forEach(function (name) {
    var el = root.querySelector('[name="' + name + '"]');
    if (!el) return;
    el.addEventListener("input", compute);
    el.addEventListener("change", compute);
  });

  // Init
  showScope(travel);
  compute();

  if (!customElements.get("speediance-calculator")) {
    class SpeedianceCalculator extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          stepBtn: null,
          stepCards: null,
          numberInputs: null, // To store all number inputs
        };
        this.currentStep = 1; // Steps are 1-based (e.g., Step 1, 2, 3)

        // Texts and classes for the button states
        this.btnTexts = {
          next: "Next",
          check: "Check Result",
          init: "Start Over",
        };
        this.btnClasses = {
          next: "button--gradient",
          init: "button--secondary",
        };

        // Bind 'this' for the event handler once
        this._handleStepChange = this._handleStepChange.bind(this);
        this._handleNumberInput = this._handleNumberInput.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      setupElements() {
        this.elements.stepBtn = this.querySelector(
          '[data-component="step-btn"]',
        );
        this.elements.stepCards = this.querySelectorAll(
          '[data-component="step"]',
        );

        this.elements.numberInputs = this.querySelectorAll(
          'input\[type="number"]',
        );

        if (!this.elements.stepBtn || this.elements.stepCards.length === 0) {
          console.error(
            "Calculator component is missing required elements (step button or step cards).",
          );
        }
      }

      addEventListeners() {
        if (this.elements.stepBtn) {
          this.elements.stepBtn.addEventListener(
            "click",
            this._handleStepChange,
          );
        }

        this.elements.numberInputs.forEach((input) => {
          input.addEventListener("input", this._handleNumberInput);
        });
      }

      removeEventListeners() {
        if (this.elements.stepBtn) {
          this.elements.stepBtn.removeEventListener(
            "click",
            this._handleStepChange,
          );
        }
      }

      /**
       *  Enforces the 'max' attribute on number inputs.
       * Prevents the user from manually typing a value greater than the max.
       */
      _handleNumberInput(event) {
        const input = event.target;
        const maxAttr = input.getAttribute("max");

        // Only proceed if a 'max' attribute exists.
        if (maxAttr === null || maxAttr === "") return;

        const maxValue = parseFloat(maxAttr);

        // If the input's value exceeds the max, set it to the max.
        if (parseFloat(input.value) > maxValue) {
          input.value = maxValue;
        }
      }

      /**
       * Main logic handler for the step button.
       * It either advances to the next step or resets the calculator.
       */
      _handleStepChange() {
        const totalSteps = this.elements.stepCards.length;

        // If we are on the last step, the button action is to reset
        if (this.currentStep === totalSteps) {
          this._reset();
        } else {
          // Otherwise, advance to the next step
          this.currentStep++;
          this._updateView();
        }
      }

      /**
       * Resets the calculator to the first step.
       */
      _reset() {
        this.currentStep = 1;
        this._updateView();
      }

      /**
       * Updates the DOM to reflect the current step.
       * This function handles card visibility and button state.
       */
      _updateView() {
        const totalSteps = this.elements.stepCards.length;
        const btn = this.elements.stepBtn;

        // Update visibility of the step cards
        this.elements.stepCards.forEach((card, index) => {
          // The index is 0-based, while currentStep is 1-based
          if (index + 1 === this.currentStep) {
            card.classList.add("current-step");
          } else {
            card.classList.remove("current-step");
          }
        });

        // Update the button's text and classes based on the new step
        btn.classList.remove(this.btnClasses.next, this.btnClasses.init);

        if (this.currentStep === totalSteps) {
          // We are now on the LAST step (the results)
          btn.innerHTML = `<span>${this.btnTexts.init}</span>`;
          btn.classList.add(this.btnClasses.init);
        } else if (this.currentStep === totalSteps - 1) {
          // We are now on the step BEFORE the results
          btn.innerHTML = `<span>${this.btnTexts.check}</span>`;
          btn.classList.add(this.btnClasses.next);
        } else {
          // We are on any other step
          btn.innerHTML = `<span>${this.btnTexts.next}</span>`;
          btn.classList.add(this.btnClasses.next);
        }
      }
    }

    customElements.define("speediance-calculator", SpeedianceCalculator);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-slider"] && !Shopify.designMode) return;
  try {
    
"use strict";
(function () {
  if (!customElements.get("featured-slider")) {
    class FeaturedSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
        this.swiper = null;
      }
      connectedCallback() {
        this.setupElements();
        this.initSwiper();
      }
      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy();
        }
      }
      setupElements() {
        this.slider = this.querySelector('[data-component="slider"]');
        this.scrollbar = this.querySelector(".swiper-scrollbar");
        this.btnNext = this.querySelector(".swiper-button-next");
        this.btnPrev = this.querySelector(".swiper-button-prev");
      }

      getOriginalSlides() {
        const swiperWrapper = this.slider.querySelector(".swiper-wrapper");
        if (!swiperWrapper) return [];
        return Array.from(
          swiperWrapper.querySelectorAll(".swiper-slide:not([data-cloned])"),
        );
      }

      calculateCloneCount(originalCount, maxSlidesPerView) {
        // Need at least maxSlidesPerView * 1.5 slides for proper looping
        const minRequired = Math.ceil(maxSlidesPerView * 1.5);

        if (originalCount >= minRequired) {
          return 0; // No cloning needed
        }

        // Calculate how many times we need to clone to reach minimum
        const timesToClone = Math.ceil(minRequired / originalCount);
        return timesToClone - 1; // -1 because we already have original
      }

      cloneSlides(timesToClone) {
        if (timesToClone <= 0) return;

        const swiperWrapper = this.slider.querySelector(".swiper-wrapper");
        const originalSlides = this.getOriginalSlides();

        if (originalSlides.length === 0) return;

        for (let i = 0; i < timesToClone; i++) {
          originalSlides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.setAttribute("data-cloned", "true");
            swiperWrapper.appendChild(clone);
          });
        }
      }

      initSwiper() {
        if (!this.slider) return;

        let {
          spaceBetween,
          spaceBetweenMb,
          spaceBetweenTb,
          slidesPerView,
          slidesPerViewTb,
          slidesPerViewMb,
          sliderLength,
          autoplay,
          loop,
          centeredSlides,
          rotate,
        } = this.dataset;

        loop = loop === "true";
        centeredSlides = centeredSlides === "true";
        rotate = +rotate * 1000;
        autoplay =
          autoplay == "true"
            ? {
                delay: rotate,
                disableOnInteraction: false,
              }
            : false;

        sliderLength = +sliderLength;
        spaceBetween = +spaceBetween.replace("px", "");
        spaceBetweenMb = +spaceBetweenMb.replace("px", "");
        spaceBetweenTb = +spaceBetweenTb.replace("px", "");
        slidesPerView =
          slidesPerView > sliderLength ? sliderLength : +slidesPerView;
        slidesPerViewTb =
          slidesPerViewTb > sliderLength ? sliderLength : +slidesPerViewTb;
        slidesPerViewMb =
          slidesPerViewMb > sliderLength ? sliderLength : +slidesPerViewMb;

        // Clone slides only if loop is enabled and not enough slides
        if (loop) {
          const maxSlides = Math.max(
            slidesPerView,
            slidesPerViewTb,
            slidesPerViewMb,
          );
          const cloneCount = this.calculateCloneCount(sliderLength, maxSlides);
          this.cloneSlides(cloneCount);

          if (cloneCount > 0) {
            console.log(
              `Cloned slides ${cloneCount} times (original: ${sliderLength}, max view: ${maxSlides})`,
            );
          }
        }

        this.swiper = new Swiper(this.slider, {
          slidesPerView: slidesPerViewMb,
          spaceBetween: spaceBetweenMb,
          grabCursor: true,
          centeredSlides: centeredSlides,
          slideToClickedSlide: true,
          loop: loop,
          navigation: {
            nextEl: this.btnNext,
            prevEl: this.btnPrev,
          },
          scrollbar: {
            el: this.scrollbar,
            draggable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewTb,
              spaceBetween: spaceBetweenTb,
            },
            990: {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetween,
            },
          },
          autoplay,
        });
      }
    }
    customElements.define("featured-slider", FeaturedSlider);
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-gallery"] && !Shopify.designMode) return;
  try {
    
"use strict";
(function () {
  if (!customElements.get("grid-gallery")) {
    class GridGallery extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperWrapper = null;
        this.breakpoint = 989;
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.checkAndInitSwiper();
        window.addEventListener("resize", this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.handleResize);
        this.destroySwiper();
      }

      setupElements() {
        this.slides = this.querySelectorAll(".flip-card");
        this.slider = this.querySelector('[data-component="slider"]');
        this.scrollbar = this.querySelector(".swiper-scrollbar");
        this.btnNext = this.querySelector(".swiper-button-next");
        this.btnPrev = this.querySelector(".swiper-button-prev");
      }

      isMobile() {
        const documentWidth = window.innerWidth;
        return documentWidth < this.breakpoint;
      }

      handleResize() {
        if (this.isMobile() && !this.swiper) {
          this.checkAndInitSwiper();
        } else if (!this.isMobile() && this.swiper) {
          this.destroySwiper();
        }
      }

      checkAndInitSwiper() {
        if (this.isMobile()) {
          this.setupSwiperStructure();
          this.initSwiper();
        }
      }

      setupSwiperStructure() {
        // Add swiper class to slider
        this.slider.classList.add("swiper");

        // Create swiper-wrapper
        this.swiperWrapper = document.createElement("div");
        this.swiperWrapper.classList.add("swiper-wrapper");

        // Move all slides into wrapper and add swiper-slide class
        this.slides.forEach((slide) => {
          slide.classList.add("swiper-slide");
          this.swiperWrapper.appendChild(slide);
        });

        // Append wrapper to slider
        this.slider.appendChild(this.swiperWrapper);
      }

      cleanupSwiperStructure() {
        if (!this.swiperWrapper) return;

        // Remove swiper-slide class and move slides back to slider
        const slides = this.swiperWrapper.querySelectorAll(".swiper-slide");
        slides.forEach((slide) => {
          slide.classList.remove("swiper-slide");
          this.slider.appendChild(slide);
        });

        // Remove wrapper
        this.swiperWrapper.remove();
        this.swiperWrapper = null;

        // Remove swiper class from slider
        this.slider.classList.remove("swiper");
      }

      initSwiper() {
        let { spaceBetween, spaceBetweenMb, slidesPerViewMb, slidesPerViewTb } =
          this.dataset;

        const sliderLength = this.slides.length || 1;

        slidesPerViewTb =
          slidesPerViewTb > sliderLength ? sliderLength : +slidesPerViewTb;
        slidesPerViewMb =
          slidesPerViewMb > sliderLength ? sliderLength : +slidesPerViewMb;

        spaceBetween = +spaceBetween.replace("px", "");
        spaceBetweenMb = +spaceBetweenMb.replace("px", "");

        this.swiper = new Swiper(this.slider, {
          slidesPerView: slidesPerViewMb,
          spaceBetween: spaceBetweenMb,
          grabCursor: true,
          navigation: {
            nextEl: this.btnNext,
            prevEl: this.btnPrev,
          },
          scrollbar: {
            el: this.scrollbar,
            draggable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewTb,
              spaceBetween: spaceBetween,
            },
          },
        });
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        this.cleanupSwiperStructure();
      }
    }

    customElements.define("grid-gallery", GridGallery);
  }
})();

(function () {
  if (!customElements.get("flip-card")) {
    class FlipCard extends HTMLElement {
      constructor() {
        super();
        this.isFlipped = false;
      }

      connectedCallback() {
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        this.addEventListener("click", this.handleClick);
        this.addEventListener("keydown", this.handleKeydown);
        // Optional: Close when clicking outside
        document.addEventListener("click", this.handleOutsideClick);
      }

      removeEventListeners() {
        this.removeEventListener("click", this.handleClick);
        this.removeEventListener("keydown", this.handleKeydown);
        document.removeEventListener("click", this.handleOutsideClick);
      }

      handleClick = (e) => {
        e.stopPropagation();
        this.toggleFlip();
      };

      handleKeydown = (e) => {
        // Handle Enter and Space keys
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.toggleFlip();
        }
        // Handle Escape key to close
        if (e.key === "Escape" && this.isFlipped) {
          this.toggleFlip();
        }
      };

      handleOutsideClick = (e) => {
        if (this.isFlipped && !this.contains(e.target)) {
          this.toggleFlip();
        }
      };

      toggleFlip() {
        this.isFlipped = !this.isFlipped;

        if (this.isFlipped) {
          this.classList.add("active");
        } else {
          this.classList.remove("active");
        }
      }
    }

    customElements.define("flip-card", FlipCard);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this)
    }

    connectedCallback() {
      this.classList.add('initialized')
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.headerTransparent = this.header.querySelector('.header-transparent');

			if(this.headerTransparent){
				const setTopPosition = () => { 
					this.headerTopPosition = this.header.offsetHeight;
					this.header.style.marginBottom = `-${this.header.offsetHeight}px`;
				}

				setTopPosition();

				let resizeTimeout;
				window.addEventListener('resize', () => {
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(setTopPosition, 60);
				});
      } 

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      if (scrollTop === 0 ) {
				this.classList.add('header-at-top');
			} else {
				this.classList.remove('header-at-top');
			}

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
"use strict";
(function () {
  if (!customElements.get("reviews-grid")) {
    class RviewsGrid extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperWrapper = null;
        this.breakpoint = 989;
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.checkAndInitSwiper();
        window.addEventListener("resize", this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.handleResize);
        this.destroySwiper();
      }

      setupElements() {
        this.slides = this.querySelectorAll(".review");
        this.slider = this.querySelector('[data-component="slider"]');
        this.scrollbar = this.querySelector(".swiper-scrollbar");
        this.btnNext = this.querySelector(".swiper-button-next");
        this.btnPrev = this.querySelector(".swiper-button-prev");
      }

      isMobile() {
        const documentWidth = window.innerWidth;
        return documentWidth < this.breakpoint;
      }

      handleResize() {
        if (this.isMobile() && !this.swiper) {
          this.checkAndInitSwiper();
        } else if (!this.isMobile() && this.swiper) {
          this.destroySwiper();
        }
      }

      checkAndInitSwiper() {
        if (this.isMobile()) {
          this.setupSwiperStructure();
          this.initSwiper();
        }
      }

      setupSwiperStructure() {
        // Add swiper class to slider
        this.slider.classList.add("swiper");

        // Create swiper-wrapper
        this.swiperWrapper = document.createElement("div");
        this.swiperWrapper.classList.add("swiper-wrapper");

        // Move all slides into wrapper and add swiper-slide class
        this.slides.forEach((slide) => {
          slide.classList.add("swiper-slide");
          this.swiperWrapper.appendChild(slide);
        });

        // Append wrapper to slider
        this.slider.appendChild(this.swiperWrapper);
      }

      cleanupSwiperStructure() {
        if (!this.swiperWrapper) return;

        // Remove swiper-slide class and move slides back to slider
        const slides = this.swiperWrapper.querySelectorAll(".swiper-slide");
        slides.forEach((slide) => {
          slide.classList.remove("swiper-slide");
          this.slider.appendChild(slide);
        });

        // Remove wrapper
        this.swiperWrapper.remove();
        this.swiperWrapper = null;

        // Remove swiper class from slider
        this.slider.classList.remove("swiper");
      }

      initSwiper() {
        let { spaceBetween, spaceBetweenMb, slidesPerViewMb, slidesPerViewTb } =
          this.dataset;

        const sliderLength = this.slides.length || 1;

        slidesPerViewTb =
          slidesPerViewTb > sliderLength ? sliderLength : +slidesPerViewTb;
        slidesPerViewMb =
          slidesPerViewMb > sliderLength ? sliderLength : +slidesPerViewMb;

        spaceBetween = +spaceBetween.replace("px", "");
        spaceBetweenMb = +spaceBetweenMb.replace("px", "");

        this.swiper = new Swiper(this.slider, {
          slidesPerView: slidesPerViewMb,
          spaceBetween: spaceBetweenMb,
          grabCursor: true,
          navigation: {
            nextEl: this.btnNext,
            prevEl: this.btnPrev,
          },
          scrollbar: {
            el: this.scrollbar,
            draggable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewTb,
              spaceBetween: spaceBetween,
            },
          },
        });
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        this.cleanupSwiperStructure();
      }
    }

    customElements.define("reviews-grid", RviewsGrid);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faqs"] && !Shopify.designMode) return;
  try {
    
"use strict";

(function () {
  if (customElements.get("faqs-section")) return;

  class FaqsSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupElements();
      if (!this.tabs.length) return; // Exit if no tabs are present
      this.attachEventListeners();
    }

    setupElements() {
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
    }

    attachEventListeners() {
      if (this.tablist) {
        this.tablist.addEventListener("click", this.onTabClick.bind(this));
        this.tablist.addEventListener("keydown", this.onTabKeydown.bind(this));
      }
    }

    onTabClick(event) {
      const clickedTab = event.target.closest('[role="tab"]');
      if (!clickedTab) return;
      this.switchTab(clickedTab);
    }

    onTabKeydown(event) {
      const key = event.key;
      if (key !== "ArrowLeft" && key !== "ArrowRight") return;

      const activeTab = document.activeElement.closest('[role="tab"]');
      if (!activeTab) return;

      const tabIndex = Array.from(this.tabs).indexOf(activeTab);
      let nextIndex = 0;

      if (key === "ArrowLeft") {
        nextIndex = tabIndex - 1 < 0 ? this.tabs.length - 1 : tabIndex - 1;
      } else if (key === "ArrowRight") {
        nextIndex = tabIndex + 1 >= this.tabs.length ? 0 : tabIndex + 1;
      }
      
      this.tabs[nextIndex].focus();
      this.switchTab(this.tabs[nextIndex]);
    }

    switchTab(newTab) {
      const panelId = newTab.getAttribute("aria-controls");
      const targetPanel = this.querySelector(`#${panelId}`);

      // Deactivate all tabs and hide all panels
      this.tabs.forEach((tab) => {
        tab.setAttribute("aria-selected", "false");
        tab.setAttribute("tabindex", "-1");
      });
      this.panels.forEach((panel) => {
        panel.setAttribute("hidden", "true");
      });

      // Activate the new tab and show its panel
      newTab.setAttribute("aria-selected", "true");
      newTab.setAttribute("tabindex", "0");
      targetPanel.removeAttribute("hidden");
    }
  }

  customElements.define("faqs-section", FaqsSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-slider"] && !Shopify.designMode) return;
  try {
    
"use strict";
(function () {
  if (!customElements.get("timeline-slider")) {
    class TimelineSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
        this.thumbnailSlider = null;
        this.swiper = null;
        this.thumbnailSwiper = null;
      }
      connectedCallback() {
        this.setupElements();
        this.initSwiper();
      }
      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy();
        }
        if (this.thumbnailSwiper) {
          this.thumbnailSwiper.destroy();
        }
      }
      setupElements() {
        this.slider = this.querySelector('[data-component="slider"]');
        this.thumbnailSlider = this.querySelector(
          '[data-component="thumbnail"]',
        );
        this.scrollbar = this.querySelector(".swiper-scrollbar");
        this.btnNext = this.querySelector(".swiper-button-next");
        this.btnPrev = this.querySelector(".swiper-button-prev");
      }
      initSwiper() {
        if (!this.slider) return;

        let {
          spaceBetween,
          spaceBetweenMb,
          slidesPerView,
          slidesPerViewTb,
          slidesPerViewMb,
          sliderLength,
          autoplay,
          rotate,
        } = this.dataset;

        rotate = +rotate * 1000;
        autoplay =
          autoplay == "true"
            ? {
                delay: rotate,
                disableOnInteraction: false,
              }
            : false;
        spaceBetween = +spaceBetween.replace("px", "");
        spaceBetweenMb = +spaceBetweenMb.replace("px", "");
        slidesPerView =
          slidesPerView > sliderLength ? sliderLength : +slidesPerView;
        slidesPerViewTb =
          slidesPerViewTb > sliderLength ? sliderLength : +slidesPerViewTb;
        slidesPerViewMb =
          slidesPerViewMb > sliderLength ? sliderLength : +slidesPerViewMb;

        // Initialize thumbnail slider first
        if (this.thumbnailSlider) {
          const thumbnailSlidesPerView = sliderLength > 5 ? 5 : sliderLength;
          this.thumbnailSwiper = new Swiper(this.thumbnailSlider, {
            grabCursor: true,
            slidesPerView: thumbnailSlidesPerView,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
          });
        }

        // Initialize main slider with thumbnail sync
        this.swiper = new Swiper(this.slider, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: spaceBetweenMb,
          slideToClickedSlide: true,
          grabCursor: true,
          navigation: {
            nextEl: this.btnNext,
            prevEl: this.btnPrev,
          },
          scrollbar: {
            el: this.scrollbar,
            draggable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewTb,
              slidesPerGroup: 1,
              spaceBetween: spaceBetween,
            },
            990: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: spaceBetween,
            },
          },
          autoplay,
          thumbs: {
            swiper: this.thumbnailSwiper,
          },
        });
      }
    }
    customElements.define("timeline-slider", TimelineSlider);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
